import request from '@/utils/request3'
import store from '@/store'
const serviceName = store.state.serviceName.workOrder;
import qs from 'qs'

//工单列表查询
export function postWorkOrderList(data) {
    return request({
        url: serviceName + `/work-order/page`,
        method: 'post',
        data: data
    })
}
//销售创建工单
export function postWorkOrderCreate(data) {
    return request({
        url: serviceName + `/work-order/create`,
        method: 'post',
        data: data,
    })
}
//销售变更工单
export function postWorkOrderChange(data) {
    return request({
        url: serviceName + `/work-order/change`,
        method: 'post',
        data: data
    })
}
//部门主管接收工单
export function postWorkOrderReceive(data) {
    return request({
        url: serviceName + `/work-order/receive`,
        method: 'post',
        data: data
    })
}
//员工接收工单
export function postWorkPickUp(data) {
    return request({
        url: serviceName + `/work-order/receive`,
        method: 'post',
        data: data
    })
}
//通过工单id查询所有任务详情
export function orderInfoTasks(data) {
    return request({
        url: serviceName + `/work-order/info-tasks?id=${data}`,
        method: 'get',
    })
}
//通过部门id获取部门下人员执行的任务数量
export function getPersonTask(data) {
    return request({
        url: serviceName + `/order-task/get-person-task?deptId=${data}`,
        method: 'post',
    })
}
//工单站内评价
export function postEvaluatea(data) {
    return request({
        url: serviceName + `/order-evaluate/evaluate`,
        method: 'post',
        data: data
    })
}
//工单站内评价详情
export function getEvaluateaId(data) {
    return request({
        url: serviceName + `/order-evaluate/getById?id=${data}`,
        method: 'get',
    })
}
//查询当前登录用户的商机
export function getProjects(data) {
    return request({
        url: serviceName + `/work-order/get-projects`,
        method: 'get',
    })
}
//查询所有的商机
export function getAllProject(data) {
    return request({
        url: serviceName + `/dim/project`,
        method: 'get',
        data: data
    })
}
//工单删除
export function postWorkOrderDelete(data) {
    return request({
        url: serviceName + `/work-order/remove-order?orderId=${data}`,
        method: 'get',
    })
}

// 获取立项汇总数据
export function getSaleSumReport(data) {
    return request({
        url: serviceName + `/sale/sum_report?` + qs.stringify(data),
        method: 'get',
    })
}